export const executionStepDescriptions = {
  "External Application": {
    "Data Breach": {
      Description:
        "Attacker is abusing the application to extract and manipulate sensitive data including financial, PII and Intellectual Property(IP) data.",
      Links: [
        { label: "TA0009", link: "https://attack.mitre.org/tactics/TA0009/" },
        { label: "TA0010", link: "https://attack.mitre.org/tactics/TA0010/" },
        { label: "T1020", link: "https://attack.mitre.org/techniques/T1020/" },
        { label: "T1041", link: "https://attack.mitre.org/techniques/T1041/" },
      ],
    },

    Ransomware: {
      Description:
        "Application's data is encrypted using a dedicated ransomware leading to extortion of funds by the attacker.",
      Links: [
        { label: "TA0040", link: "https://attack.mitre.org/tactics/TA0040/" },
        { label: "T1486", link: "https://attack.mitre.org/techniques/T1486/" },
        { label: "T1485", link: "https://attack.mitre.org/techniques/T1485/" },
      ],
    },
  },

  "Internal Application": {
    "Data Breach": {
      Description:
        "Attacker is abusing the application to extract and manipulate sensitive data including financial, PII and Intellectual Property(IP) data.",
      Links: [
        { label: "TA0009", link: "https://attack.mitre.org/tactics/TA0009/" },
        { label: "TA0010", link: "https://attack.mitre.org/tactics/TA0010/" },
        { label: "T1020", link: "https://attack.mitre.org/techniques/T1020/" },
        { label: "T1041", link: "https://attack.mitre.org/techniques/T1041/" },
      ],
    },

    Ransomware: {
      Description:
        "Application's data is encrypted using a dedicated ransomware leading to extortion of funds by the attacker.",
      Link: [
        { label: "TA0040", link: "https://attack.mitre.org/tactics/TA0040/" },
        { label: "T1486", link: "https://attack.mitre.org/techniques/T1486/" },
        { label: "T1485", link: "https://attack.mitre.org/techniques/T1485/" },
      ],
    },
  },

  "Key People": {
    "Data Breach": {
      Description:
        "Using compromised highly privileged credentials, sensitive data is accessed and exfiltrated to an attacker-controlled machine.",
      Links: [
        { label: "TA0006", link: "https://attack.mitre.org/tactics/TA0006/" },
        { label: "TA0040", link: "https://attack.mitre.org/tactics/TA0040/" },
        { label: "TA0010", link: "https://attack.mitre.org/tactics/TA0010/" },
      ],
    },

    Ransomware: {
      Description:
        "The attacker leverages compromised key credentials to abuse sensitive systems leading to ransomware executed across the estate.",
      Links: [
        { label: "TA0006", link: "https://attack.mitre.org/tactics/TA0006/" },
        { label: "TA0009", link: "https://attack.mitre.org/tactics/TA0009/" },
        { label: "T1486", link: "https://attack.mitre.org/techniques/T1486/" },
      ],
    },
  },
  "Sensitive Data": {
    "Data Breach": {
      Description: `Attacker is able to access restricted data, exfiltrate valuable data parts, perform unauthorized modifications and destroy the data to impact availability.`,
      Links: [
        { label: "T1657", link: "https://attack.mitre.org/techniques/T1657/" },
        { label: "TA0010", link: "https://attack.mitre.org/tactics/TA0010/" },
        { label: "T1565", link: "https://attack.mitre.org/techniques/T1565/" },
      ],
    },

    Ransomware: {
      Description: `The attacker denies access to the data using a ransomware bringing business operations to a halt.`,
      Links: [
        { label: "TA0040", link: "https://attack.mitre.org/tactics/TA0040/" },
        { label: "T1486", link: "https://attack.mitre.org/techniques/T1486/" },
        { label: "T1485", link: "https://attack.mitre.org/techniques/T1485/" },
      ],
    },
  },
};

export const executionStepDescriptorByAssetType = {
  "External Application": "StaticExecutionExternalApplication",
  "Internal Application": "StaticExecutionInternalApplication",
  "Key People": "StaticExecutionKeyPeople",
  "Sensitive Data": "StaticExecutionSensitiveData",
  Other: "StaticExecution",
};
